"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldSkipBenefitBannerFetch = exports.isTopAreaBannerVisible = exports.isOrderOnBehalfVisible = exports.isLoading = void 0;
const isLoading = ({
  isAnonymousWithStore,
  loadingVipAccess,
  orderOnBehalfVisible,
  topBannerVisible,
  isLoadingTopBanner
}) => loadingVipAccess || !isAnonymousWithStore && !orderOnBehalfVisible && !topBannerVisible ||
// isLoadingTopBanner could be deleted when all markets are migrated to the new banners
isAnonymousWithStore && isLoadingTopBanner && !topBannerVisible;
exports.isLoading = isLoading;
const isOrderOnBehalfVisible = orderOnBehalfData => !!orderOnBehalfData?.VipAccessData?.ConsultantName && orderOnBehalfData.VipAccessData.ConsultantNumber > 0 && !!orderOnBehalfData.VipAccessLabels?.ConsultantChangeConsultantNumber && orderOnBehalfData.VipAccessData.Links.length > 0;
exports.isOrderOnBehalfVisible = isOrderOnBehalfVisible;
const isTopAreaBannerVisible = bannersData => !!bannersData && bannersData.length > 0;
exports.isTopAreaBannerVisible = isTopAreaBannerVisible;
const shouldSkipBenefitBannerFetch = ({
  enableTopAreaBanner,
  isAnonymousWithStore,
  loadingSegmentationData,
  orderOnBehalfVisible
}) => loadingSegmentationData || orderOnBehalfVisible || !enableTopAreaBanner || isAnonymousWithStore;
exports.shouldSkipBenefitBannerFetch = shouldSkipBenefitBannerFetch;
